// USED FOR STICKY HEADER / STICKY ANNOUCEMENT BAR / STICKY FACETS
class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        sticky: `shopify-section-${this.dataset.sectionName}-sticky`,
        hidden: `shopify-section-${this.dataset.sectionName}-hidden`
      }
    }

    connectedCallback() {
      this.header = this.parentElement
      
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add(this.classes.sticky);
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const { hideOn } = this.dataset;
      if(window.matchMedia(`(max-width: 991px)`).matches && hideOn === 'mobile' || window.matchMedia(`(min-width: 992px)`).matches && hideOn === 'desktop') return;
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }

      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {  
      if(!window.matchMedia(`(max-width: 991px)`).matches && this.dataset.hideOn === 'mobile' || !window.matchMedia(`(min-width: 992px)`).matches && this.dataset.hideOn === 'desktop'){
        publish('sticky-header:stick', 'close');
      }

      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add(this.classes.hidden, this.classes.sticky);
      
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if(!window.matchMedia(`(max-width: 991px)`).matches && this.dataset.hideOn === 'mobile' || !window.matchMedia(`(min-width: 992px)`).matches && this.dataset.hideOn === 'desktop'){
        publish('sticky-header:stick', 'open');
      }
      
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add(this.classes.hidden, 'animate');
      this.header.classList.remove(this.classes.hidden);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(this.classes.hidden, this.classes.sticky, 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal && this.searchModal.close(false)
    }
  }

  customElements.define('sticky-header', StickyHeader);